import { Image, useTheme, View, Text, Link } from "@aws-amplify/ui-react";

import { useLabelOptions } from "contexts/labelOptionsContext";

import useStyles from "./sheet";

const AsideWL = () => {
  const { tokens } = useTheme();
  const {
    labelOptions: {
      headLogo,
      asideCenterLogo,
      loginSlogan,
      asidePoweredBy,
      styles,
    },
  } = useLabelOptions();



  const classes = useStyles({ tokens });
  return (
    <View
      width={{
        large: "100%",
        base: "100vw",
      }}
      height={{
        large: "100%",
        base: "100vh",
      }}
      {...styles.aside}
      className={classes.asideWLContainer}
    >
      <View
        className={classes.asideWL}
        display={{ base: "none", large: "flex" }}
      >
        {headLogo && (
          <View width={160} margin={`${tokens.space.medium} auto`}>
            <Image alt={headLogo.alt} src={headLogo.src} width="100%" />
          </View>
        )}
        <View maxWidth={300} margin="auto" {...asideCenterLogo.style}>
          <Image alt={asideCenterLogo.alt} src={asideCenterLogo.src} width="100%" />
          {loginSlogan && (
            <Text
              marginTop={tokens.space.xs}
              color={tokens.colors.white}
              textTransform="uppercase"
              textAlign="center"
            >
              {loginSlogan}
            </Text>
          )}
        </View>
        {asidePoweredBy && (
          <View margin={`0 auto ${tokens.space.xs} auto`}>
            <Link
              href="https://www.dokka.com"
              isExternal
              color={tokens.colors.white}
            >
              Powered by DOKKA
            </Link>
          </View>
        )}
      </View>
    </View>
  );
};

export default AsideWL;
